import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import { useShargeUser } from "./Hooks";
import { CostRender } from "../../../Common/Function";
import { Spinner } from "react-bootstrap";

function List() {
  const {
    list,
    loading,
    getData,
    dataSearch,
    searchType,
    setsearchType,
    handlerSearch,
    setModal,
    modal,
    price,
    setPrice,
    shargeWallet,
    loadingBtn,
    setLoadingBtn,
  } = useShargeUser();

  useEffect(() => {
    getData();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مجموعه ها</title>
      </Helmet>

      <DataTable
        loading={loading}
        heads={[
          {
            title: "عنوان",
            key: "fullname",
          },
          {
            title: "موبایل",
            key: "mobile",
          },
          {
            title: "موجودی کیف پول",
            keyName: "amount",
            key: "client_wallet",
          },
          {
            title: "جنسیت",
            key: "gender",
            type: "enum",
            enum: {
              woman: "خانم",
              man: "آقا",
              null: "ثبت نشده",
            },
          },
          {
            title: "کد ملی",
            key: "national_code",
          },
          {
            title: "وضعیت کاربر",
            key: "status",
            type: "enum",
            enum: {
              active: "فعال",
              dactive: "غیرفعال",
              notpassword: "فعال ",
            },
          },
          {
            title: "زمان ثبت اطلاعات",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="کاربری ثبت نشده"
        list={list && list.data}
        data={list}
        search={handlerSearch}
        function={getData}
        currentPage={list && list.data && list.data.current_page}
        header=" لیست اطلاعات کاربران"
        linkbtn="/Admin/User/Create"
        links={[
          {
            function: selected => {
              setModal({ sharge: selected[0] });
            },
            color: "primary",
            size: "col-md-5",
            html: "شارژ کیف پول",
            multi: true,
            type: "go",
            main: true,
          },
        ]}
      />

      <CustomModal
        size={"md"}
        show={modal.sharge}
        handleClose={() => {
          setModal({ sharge: false });
        }}
        header={"شارژ کیف پول"}
      >
        <ShargeWallet
          submit={shargeWallet}
          price={price}
          loadingBtn={loadingBtn}
          setPrice={setPrice}
        />
      </CustomModal>
    </Fragment>
  );
}

const ShargeWallet = ({ price, setPrice, submit, loadingBtn }) => {
  return (
    <div>
      <div className="input-group mb-3 align-items-center">
        <input
          value={price}
          className="form-control"
          type="number"
          step={10000}
          placeholder="مبلغ"
          onChange={({ target: { value } }) => setPrice(value)}
        />
        <p
          className="text-center "
          style={{
            marginRight: "20px",
            marginBottom: "0",
          }}
        >{`${CostRender.format(price)} تومان`}</p>
      </div>
  
      <div>
        <button
          className="btn btn-primary btn-block"
          onClick={submit}
          disabled={loadingBtn}
        >
          {loadingBtn ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            "شارژ"
          )}
        </button>
      </div>
    </div>
  );
};

export default List;
